import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "fillColor", "fillGray", "fillLightGray", "fillCautionColor", "fillTransparentGray", "borderBlue", "borderGray", "borderLight", "borderCaution", "fontFixed", "fontBold", "large", "medium", "small", "largeFont", "favBtn", "favBtnWithLabel", "listRow", "scale", "inline", "transparent", "atagProps", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from "react";
import classnames from "classnames";
import buttonStyles from "@/styles/Button.module.scss";
import VersatileLink from "@/components/VersatileLink";
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonLink = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className,
      fillColor,
      fillGray,
      fillLightGray,
      fillCautionColor,
      fillTransparentGray,
      borderBlue,
      borderGray,
      borderLight,
      borderCaution,
      fontFixed,
      fontBold,
      large,
      medium,
      small,
      largeFont,
      favBtn,
      favBtnWithLabel,
      listRow,
      scale,
      inline,
      transparent,
      atagProps = {},
      disabled
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(VersatileLink, _objectSpread(_objectSpread({}, _props), {}, {
    children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      ref: ref,
      className: classnames(buttonStyles.btn, className, {
        [buttonStyles.fillColor]: fillColor,
        [buttonStyles.fillGray]: fillGray,
        [buttonStyles.fillLightGray]: fillLightGray,
        [buttonStyles.fillCautionColor]: fillCautionColor,
        [buttonStyles.fillTransparentGray]: fillTransparentGray,
        [buttonStyles.borderBlue]: borderBlue,
        [buttonStyles.borderGray]: borderGray,
        [buttonStyles.borderLight]: borderLight,
        [buttonStyles.borderCaution]: borderCaution,
        [buttonStyles.fontFixed]: fontFixed,
        [buttonStyles.fontBold]: fontBold,
        [buttonStyles.large]: large,
        [buttonStyles.medium]: medium,
        [buttonStyles.small]: small,
        [buttonStyles.largeFont]: largeFont,
        [buttonStyles.favBtn]: favBtn,
        [buttonStyles.favBtnWithLabel]: favBtnWithLabel,
        [buttonStyles.listRow]: listRow,
        [buttonStyles.scale]: scale,
        [buttonStyles.inline]: inline,
        [buttonStyles.transparent]: transparent,
        [buttonStyles.disabled]: disabled
      }),
      role: "button"
    }, atagProps), {}, {
      children: props.children
    }))
  }));
});
ButtonLink.displayName = "ButtonLink";
export default ButtonLink;